<script setup lang="ts">
const { steps, completedSteps } = useWorkspaceOnboarding()
</script>

<template>
  <NuxtLayout name="onboarding-base">
    <WorkspaceOnboardingLayoutTopBar>
      <ProgressIndicator :steps :completed-steps />
    </WorkspaceOnboardingLayoutTopBar>
    <div class="z-1 flex w-full max-w-3xl flex-col p-6 sm:p-10">
      <slot />
    </div>
  </NuxtLayout>
</template>
